import { apiClient } from '../client';
import { BranchData } from '../../../contract/dtos';

// Params for getting branches
interface GetBranchesParams {
  tenant_id: number;
  component_id: number;
  branches_ids?: string;
  name?: string;
  city_id?: string;
  city_name?: string;
  area_id?: string;
  area_name?: string;
  contact_person_name?: string;
  contact_person_email?: string;
  contact_person_mobile?: string;
  size?: number;
  page?: number;
  sort?:string;
}

export const createOrUpdateBranch = async (
  entityType: 'request' | 'tenant',
  entityId: string | number,
  branchData: BranchData,
  branchId?: string | number
) => {
  const response = await apiClient.put(
    `/corporate/v1/${entityType}/${entityId}/branch${branchId ? `/${branchId}` : ''}`,
    branchData
  );
  return response.data;
};

export const getBranches = async (params: GetBranchesParams) => {
  const response = await apiClient.get('/corporate/v1/branch', {
    params: {
      tenant_id: params.tenant_id,
      component_id: params.component_id,
      branches_ids: params.branches_ids,
      name: params.name,
      city_id: params.city_id,
      city_name: params.city_name,
      area_id: params.area_id,
      area_name: params.area_name,
      contact_person_name: params.contact_person_name,
      contact_person_email: params.contact_person_email,
      contact_person_mobile: params.contact_person_mobile,
      size: params.size,
      page: params.page,
      sort: params.sort,
    }
  });
  const total = parseInt(response.headers['x-total-count'] || '0', 10);

  return {
    total,
    data: response.data,
  };
};

export const setLastAccessedBranch = async (
  branchId: string | number,
  tenantId: number,
  componentId: number
) => {
  const response = await apiClient.post(
    `/corporate/v1/branch/last-accessed-branch`,
    {
      last_accessed_branch: branchId?.toString()?.includes(',') ? 'allBranches' : branchId
    },
    {
      params: {
        tenant_id: tenantId,
        component_id: componentId,
      }
    }
  );
  return response.data;
};

export interface GetBasicBranchDataParams {
  tenant_id: number;
  component_id: number;
  size?: number;
}

export const getBasicBranchData = async (params: GetBasicBranchDataParams) => {
  const response = await apiClient.get('/corporate/v1/branch/basic-data', {
    params: {
      tenant_id: params.tenant_id,
      component_id: params.component_id,
      size: params.size || 1000, 
    }
  });
  return response.data;
};

